export enum SelectionState {
  /**
   * Vide
   */
  None = 'none',
  /**
   * Check gris
   */
  MeOnly = 'me_only',
  /**
   * Double check gris
   */
  MeAndSomeChildren = 'me_and_some_children',
  /**
   * Barre gris
   */
  NotMeButSomeChildren = 'not_me_but_some_children',
  /**
   * Barre
   */
  NotMeButAllChildren = 'not_me_but_all_children',
  /**
   * Double check
   */
  MeAndAllChildren = 'me_and_all_children',
}

/**
 * States that mean that the node is checked
 */
export const CHECKED_STATES = [
  SelectionState.MeOnly,
  SelectionState.MeAndSomeChildren,
  SelectionState.MeAndAllChildren,
];

/**
 * States that mean that all children of the node are checked
 */
export const CHECKED_ALL_CHILDREN_STATES = [
  SelectionState.NotMeButAllChildren,
  SelectionState.MeAndAllChildren,
];

/**
 * States that mean at least one child of the node is checked
 */
export const CHECKED_SOME_CHILDREN_STATES = [
  SelectionState.MeAndSomeChildren,
  SelectionState.NotMeButSomeChildren,
  SelectionState.NotMeButAllChildren,
  SelectionState.MeAndAllChildren,
];
